import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const TopNavigationBarModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=qcqEpblDXkg&ab_channel=apadua" />
);

export default TopNavigationBarModal;
